import "@root/tailwind.1.app.css";
import "@local/sass/main.scss";

import { register as registerMenus } from "@local/ts/interactions/MenuInteractions";

import GLightbox from "glightbox";
window.GLightbox = GLightbox;

import { domReady, domSelectorReady } from "@local/ts/lib/Utility";
import * as IMask from "@local/ts/interactions/InputMaskInteractions";
import * as DeltaScroll from "@local/ts/interactions/DeltaScrollInteractions";
import * as ElementToggleInteractions from "@local/ts/interactions/ElementToggleInteractions";
window["ElementToggleInteractions"] = ElementToggleInteractions;
import * as GLightboxInteractions from "@local/ts/interactions/GLightboxInteractions";
import * as ShareInteractions from "@local/ts/interactions/ShareInteractions";

(async () => {
  await domReady();
  registerMenus();
  GLightboxInteractions.register();
  IMask.mask();
  DeltaScroll.register({
    dead_zone: 50,
    minimum_movement: 30,
    below_threshold: 1,
    small_width: 1024,
    small_height: 915,
  });
  ElementToggleInteractions.register();
  ShareInteractions.register();

  const body = await domSelectorReady("body");
  body[0].classList.remove("disable-animations");
})();

console.log("App loaded");
